@use "styles" as *;
@use "sass:map";

$block: me-chip;

.#{$block} {
  border: 1px solid $color-gray-300;
  border-radius: $me-chip-border-radius;
  font-size: $font-size-s;
  line-height: 1;
  color: $color-text;
  background-color: $color-background;
  padding: space(2, 2.5);
  display: inline-flex;

  @each $theme, $theme-options in $chip-themes {
    &--#{$theme} {
      background: map.get($theme-options, background);
      color: map.get($theme-options, color);
      border-color: map.get($theme-options, color-border);

      &.#{$block}--filter {
        text-transform: uppercase;
        font-weight: $font-weight-semi-bold;
        color: map.get($theme-options, color-filter);
      }

      &.#{$block}--active {
        background: map.get($theme-options, color);
        color: map.get($theme-options, background);
        border-color: map.get($theme-options, color);
      }
    }
  }

  &__search-filter-icon {
    display: none;
  }

  &--search {
    gap: space(2);

    .#{$block}__search-filter-icon {
      display: block;
    }
  }

  &--button, &--link {
    user-select: none;
    cursor: pointer;
  }
}

.fcms {
  .followed {
    .#{$block}  {
      @extend .me-chip--active;
    }
  }
}
